var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mp-radio",class:{ 'mp-radio--selected': _vm.isSelected },on:{"click":function($event){!_vm.isSelected ? _vm.$emit('click') : null}}},[_c('span',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }